var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNi = function SvgNi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 0A12 12 0 0 0 1.192 6.782H22.81A12 12 0 0 0 12 0ZM12 24.001a12 12 0 0 0 10.81-6.783H1.191a12 12 0 0 0 10.81 6.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 8.348a3.652 3.652 0 1 0 0 7.304 3.652 3.652 0 0 0 0-7.304Zm0 5.739a2.087 2.087 0 1 1 0-4.174 2.087 2.087 0 0 1 0 4.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M13.807 12.522 12 12.001l-1.808.521-.602 1.044h4.82l-.603-1.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "m12 9.391-1.205 2.087L12 12l1.205-.522L12 9.391Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M10.192 12.521h3.615l-.602-1.043h-2.41l-.603 1.043Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNi;